import { useState, useEffect, useRef } from 'react';
import './Stylesheets/Landing.css';
import InlineLeadForm from './Components/InlineLeadForm';

import p1 from './Media/ibjjf.webp';
import p2 from './Media/rhkids.webp';
import p3 from './Media/IMG_65393.webp';

const TICKER_IMGS = [p1, p2, p3];

export default function Landing() {
  const [tickerReady, setTickerReady] = useState(false);
  const trackRef = useRef(null);

  useEffect(() => {
    if (!trackRef.current) return;
    const imgs = [...trackRef.current.querySelectorAll('img')].slice(0, 2);
    let loaded = 0;
    const tryStart = () => {
      loaded += 1;
      if (loaded >= 2) setTickerReady(true);
    };
    imgs.forEach(img => {
      if (img.complete && img.naturalWidth > 0) tryStart();
      else img.addEventListener('load', tryStart, { once: true });
    });
  }, []);

  return (
    <div className="rh-landing-page">
      <section className="rh-landing-hero">

        <div className="rh-hero-ticker" aria-hidden="true">
          <div ref={trackRef} className={`rh-hero-ticker__track${tickerReady ? ' rh-hero-ticker__track--ready' : ''}`}>
            {TICKER_IMGS.map((src, i) => (
              <img key={`a-${i}`} src={src} alt="" draggable="false" />
            ))}
            {TICKER_IMGS.map((src, i) => (
              <img key={`b-${i}`} src={src} alt="" draggable="false" />
            ))}
          </div>
          <div className="rh-hero-ticker__overlay" />
        </div>

        <div className="rh-hero-title">
          <p className="rh-hero-pretitle">Richmond Hill, Ontario</p>
          <h1 className="rh-hero-name">Richmond Hill Jiu-Jitsu</h1>
          <p className="rh-hero-disciplines">BJJ &nbsp;·&nbsp; Muay Thai &nbsp;·&nbsp; Kids &nbsp;·&nbsp; Adults</p>
        </div>

        <InlineLeadForm />
      </section>
    </div>
  );
}
